import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV'
import { Button, Menu, Dropdown } from 'antd'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { IUser } from 'interfaces/users'
import { PathRoutes } from 'enum/routes'
import Remove from './remove'
import { Wrapper, OptionsWrapper } from './styled'

interface IProps {
  user: IUser
  refreshView: (options?: { resetSearch?: boolean }) => Promise<void>
  changeRole: (user: IUser) => void
}

export const Options = ({ user, refreshView, changeRole }: IProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const prefix = 'configuration.rolesAndPermissions.users.table.actions'
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const viewRolePermissions = () => {
    history.push(
      PathRoutes.ROLES_AND_PERMISSIONS_ROLES_EDIT.replace(
        ':id',
        user.role.id.toString()
      )
    )
  }

  return (
    <Wrapper>
      <Button onClick={() => changeRole(user)}>
        {t(`${prefix}.changeRole`)}
      </Button>
      <Dropdown
        placement="bottomRight"
        overlay={
          <Menu>
            <Menu.Item onClick={viewRolePermissions}>
              {t(`${prefix}.viewRolePermissions`)}
            </Menu.Item>
            <Menu.Item onClick={() => setShowDeleteModal(true)}>
              {t(`${prefix}.removeAllPermissions.title`)}
            </Menu.Item>
          </Menu>
        }
      >
        <OptionsWrapper>
          <Button type="link">
            <FontAwesomeIcon icon={faEllipsisV} />
          </Button>
        </OptionsWrapper>
      </Dropdown>
      {showDeleteModal && (
        <Remove
          user={user}
          refreshView={refreshView}
          close={() => setShowDeleteModal(false)}
        />
      )}
    </Wrapper>
  )
}

export default Options
